import CustomizableSection from 'pages/MasterCampaignPlanPage/new/components/ExecutiveSummary/CustomizableSection'
import { FC } from 'react'

import { MasterCampaignPlanCustomSection } from 'api/entities/MasterCampaignPlan'
import { MasterCampaignPlanCampaignBuilder } from 'api/entities/MasterCampaignStub'

import { getPlanDescription } from '../../utils/planContentUtils'

export interface PlanDescriptionProps {
  accountName: string
  campaigns: MasterCampaignPlanCampaignBuilder[]
  section: MasterCampaignPlanCustomSection | null | undefined
}

const PlanDescription: FC<PlanDescriptionProps> = ({ accountName, campaigns, section }) => {
  const planDescription = getPlanDescription(accountName)

  return <CustomizableSection section={section} defaultTitle='' defaultContent={planDescription.combined} defaultShowTitle={false} separator='spacer' />
}

export default PlanDescription
